import React, {
    createContext,
    PropsWithChildren,
    useEffect,
    useState
} from "react";
import { ThemeProvider } from "@pankod/refine-mui";
import {
    DarkThemeWithResponsiveFontSizes as DarkTheme,
    LightThemeWithResponsiveFontSizes as LightTheme,
} from "theme";

type ColorModeContextType = {
    mode: string;
    setMode: () => void;
};

type PagingContextType = {
    nextPageToken: string | null,
    prevPageToken: string | null,
    currentPage: number,
    setNextPageToken: (token:string) => void,
    setPrevPageToken: (token:string) => void,
    setCurrentPage: (page:number) => void
}

export const PagingContext = createContext<PagingContextType>({
    nextPageToken: null,
    prevPageToken: null,
    currentPage: 1,
    setNextPageToken: () => {},
    setPrevPageToken: () => {},
    setCurrentPage: () => {}

});

export const PagingContextProvider:React.FC<PropsWithChildren>  = ({ children }) => {
    const [nextPageToken, setNextPageToken] = useState("");
    const [prevPageToken, setPrevPageToken] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
  
    return (
      <PagingContext.Provider value={
        {
            nextPageToken: nextPageToken,
            prevPageToken: prevPageToken,
            currentPage: currentPage,
            setNextPageToken: (token:string) => setNextPageToken(token),
            setPrevPageToken: (token:string) => setPrevPageToken(token),
            setCurrentPage: (page:number) => setCurrentPage(page)
        }
        }>
        { children }
      </PagingContext.Provider>
    );
  };

export const ColorModeContext = createContext<ColorModeContextType>(
    {} as ColorModeContextType,
);

export const ColorModeContextProvider: React.FC<PropsWithChildren> = ({
    children,
}) => {
    const defaultMode = "light";

    const [mode, setMode] = useState(defaultMode);

    useEffect(() => {
        window.localStorage.setItem("colorMode", mode);
    }, [mode]);

    const setColorMode = () => {
        if (mode === "light") {
            setMode("dark");
        } else {
            setMode("light");
        }
    };

    return (
        <ColorModeContext.Provider
            value={{
                setMode: setColorMode,
                mode,
            }}
        >
            <ThemeProvider theme={mode === "light" ? LightTheme : DarkTheme}>
                {children}
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
};
